import { render, staticRenderFns } from "./NotConnected.vue?vue&type=template&id=4b0e72ba&scoped=true&"
var script = {}
import style0 from "./NotConnected.vue?vue&type=style&index=0&id=4b0e72ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e72ba",
  null
  
)

export default component.exports